import React from 'react';
import type { WidgetProps } from '../registry';
import { renderWidget } from '../registry';
import { evaluateExpression } from '../../utils/expressionEvaluator';

interface FlexLayoutProps extends WidgetProps {
  formData?: Record<string, any>;
  allErrors?: Record<string, string>;
  onFieldChange?: (name: string, value: any) => void;
}

export const SimpleFlexLayout: React.FC<FlexLayoutProps> = ({
  widget,
  onChange,
  error,
  formData = {},
  allErrors = {},
  onFieldChange,
}) => {
  const direction = widget.direction || 'row';
  const gap = widget.gap || '16px';
  const children = widget.children || [];

  // Use the provided change handler or fall back to onChange
  const handleChange = onFieldChange || onChange;

  return (
    <div
      className="rul-flex-layout"
      style={{
        display: 'flex',
        flexDirection: direction,
        gap: gap,
        width: '100%',
      }}
    >
      {children.map((childName: string) => {
        const childWidget = formData[childName];
        if (!childWidget) {
          return null;
        }

        // Check visible_when condition
        const isVisible = evaluateExpression(
          childWidget.visible_when,
          formData
        );
        if (!isVisible) {
          return null;
        }

        // Check enabled_when condition
        const isEnabled =
          childWidget.enabled !== false &&
          evaluateExpression(childWidget.enabled_when, formData);

        // Get flex style from child widget
        const flex = childWidget.css_style?.flex || '1';

        return (
          <div key={childName} style={{ flex }}>
            {renderWidget(
              { ...childWidget, name: childName, enabled: isEnabled },
              handleChange,
              allErrors[childName],
              undefined, // warning
              undefined, // onButtonClick
              { formData, allErrors } // layoutProps
            )}
          </div>
        );
      })}
    </div>
  );
};
